/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateStatusEnum } from './DateStatusEnum';
import {
    DateStatusEnumFromJSON,
    DateStatusEnumFromJSONTyped,
    DateStatusEnumToJSON,
    DateStatusEnumToJSONTyped,
} from './DateStatusEnum';
import type { SharedSettlement } from './SharedSettlement';
import {
    SharedSettlementFromJSON,
    SharedSettlementFromJSONTyped,
    SharedSettlementToJSON,
    SharedSettlementToJSONTyped,
} from './SharedSettlement';
import type { StatusAb7Enum } from './StatusAb7Enum';
import {
    StatusAb7EnumFromJSON,
    StatusAb7EnumFromJSONTyped,
    StatusAb7EnumToJSON,
    StatusAb7EnumToJSONTyped,
} from './StatusAb7Enum';
import type { BookingTerms } from './BookingTerms';
import {
    BookingTermsFromJSON,
    BookingTermsFromJSONTyped,
    BookingTermsToJSON,
    BookingTermsToJSONTyped,
} from './BookingTerms';

/**
 * Serializer for creating and updating holds.
 * Optimized for mutation operations with operational data.
 * @export
 * @interface PatchedHoldCreateUpdate
 */
export interface PatchedHoldCreateUpdate {
    /**
     * 
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly id?: string;
    /**
     *
     * @type {boolean}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly canManage?: boolean;
    /**
     *
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly hostTeam?: number;
    /**
     *
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly showTeam?: number | null;
    /**
     *
     * @type {BookingTerms}
     * @memberof PatchedHoldCreateUpdate
     */
    bookingTerms?: BookingTerms;
    /**
     *
     * @type {SharedSettlement}
     * @memberof PatchedHoldCreateUpdate
     */
    sharedSettlement?: SharedSettlement;
    /**
     *
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    hostNotes?: string;
    /**
     *
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly bookingRevision?: number;
    /**
     *
     * @type {Date}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly acceptedAt?: Date | null;
    /**
     * Title for the new show when creating a hold without an existing show.
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    title?: string;
    /**
     * Stage for this hold
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    stage?: string;
    /**
     * Date of the hold
     * @type {Date}
     * @memberof PatchedHoldCreateUpdate
     */
    holdDate?: Date;
    /**
     * Team that placed the hold
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    promoterTeam?: number;
    /**
     * Show associated with this hold (for multi-day holds)
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    show?: string | null;
    /**
     * Current status of the hold
     * 
     * * `requested` - Awaiting host acceptance
     * * `declined` - Declined by host
     * * `pending` - Pending
     * * `challenged` - Challenged
     * * `confirmed` - Confirmed
     * * `standby` - Standby
     * * `released` - Released
     * * `expired` - Expired
     * * `cancelled` - Cancelled
     * @type {StatusAb7Enum}
     * @memberof PatchedHoldCreateUpdate
     */
    status?: StatusAb7Enum;
    /**
     * Status of the date itself
     * 
     * * `open` - Open
     * * `held` - Held
     * * `confirmed` - Confirmed
     * * `unavailable` - Unavailable
     * @type {DateStatusEnum}
     * @memberof PatchedHoldCreateUpdate
     */
    dateStatus?: DateStatusEnum;
    /**
     * When this hold expires if not confirmed or challenged (14 days)
     * @type {Date}
     * @memberof PatchedHoldCreateUpdate
     */
    expiresAt?: Date | null;
    /**
     * Internal notes about this hold
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    notes?: string;
    /**
     * User who created this hold
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    readonly createdBy?: number | null;
    /**
     * Load-in time for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    loadInTime?: string | null;
    /**
     * Soundcheck time for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    soundcheckTime?: string | null;
    /**
     * Time doors open for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    doorsTime?: string | null;
    /**
     * Show start time for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    showTime?: string | null;
    /**
     * Show end time for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    endTime?: string | null;
    /**
     * Actual attendance for this specific date
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    attendance?: number | null;
    /**
     * Show-specific capacity limit for this date (may differ from venue capacity)
     * @type {number}
     * @memberof PatchedHoldCreateUpdate
     */
    showCapacity?: number | null;
    /**
     * Line-item ticket sales (e.g., [{'type': 'presale', 'name': 'Early Bird', 'quantity': 50, 'price': '25.00'}])
     * @type {any}
     * @memberof PatchedHoldCreateUpdate
     */
    ticketRevenueItems?: any | null;
    /**
     * Total ticket sales revenue for this specific date (auto-calculated)
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    barRevenue?: string | null;
    /**
     * Other revenue (merch, parking, etc.) for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    otherRevenue?: string | null;
    /**
     * Line-item expenses (e.g., [{'name': 'Security', 'amount': '100.00'}])
     * @type {any}
     * @memberof PatchedHoldCreateUpdate
     */
    expenseItems?: any | null;
    /**
     * Total production/staffing expenses for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    totalExpenses?: string | null;
    /**
     * Whether this specific date has been financially settled
     * @type {boolean}
     * @memberof PatchedHoldCreateUpdate
     */
    isSettled?: boolean;
    /**
     * Date this specific show instance was settled
     * @type {Date}
     * @memberof PatchedHoldCreateUpdate
     */
    settlementDate?: Date | null;
    /**
     * Notes about settlement for this specific date
     * @type {string}
     * @memberof PatchedHoldCreateUpdate
     */
    settlementNotes?: string;
}



/**
 * Check if a given object implements the PatchedHoldCreateUpdate interface.
 */
export function instanceOfPatchedHoldCreateUpdate(value: object): value is PatchedHoldCreateUpdate {
    return true;
}

export function PatchedHoldCreateUpdateFromJSON(json: any): PatchedHoldCreateUpdate {
    return PatchedHoldCreateUpdateFromJSONTyped(json, false);
}

export function PatchedHoldCreateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedHoldCreateUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'canManage': json['can_manage'] == null ? undefined : json['can_manage'],
        'hostTeam': json['host_team'] == null ? undefined : json['host_team'],
        'showTeam': json['show_team'] == null ? undefined : json['show_team'],
        'bookingTerms': json['booking_terms'] == null ? undefined : BookingTermsFromJSON(json['booking_terms']),
        'sharedSettlement': json['shared_settlement'] == null ? undefined : SharedSettlementFromJSON(json['shared_settlement']),
        'hostNotes': json['host_notes'] == null ? undefined : json['host_notes'],
        'bookingRevision': json['booking_revision'] == null ? undefined : json['booking_revision'],
        'acceptedAt': json['accepted_at'] == null ? undefined : (new Date(json['accepted_at'])),
        'title': json['title'] == null ? undefined : json['title'],
        'stage': json['stage'] == null ? undefined : json['stage'],
        'holdDate': json['hold_date'] == null ? undefined : (new Date(json['hold_date'])),
        'promoterTeam': json['promoter_team'] == null ? undefined : json['promoter_team'],
        'show': json['show'] == null ? undefined : json['show'],
        'status': json['status'] == null ? undefined : StatusAb7EnumFromJSON(json['status']),
        'dateStatus': json['date_status'] == null ? undefined : DateStatusEnumFromJSON(json['date_status']),
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'loadInTime': json['load_in_time'] == null ? undefined : json['load_in_time'],
        'soundcheckTime': json['soundcheck_time'] == null ? undefined : json['soundcheck_time'],
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'showCapacity': json['show_capacity'] == null ? undefined : json['show_capacity'],
        'ticketRevenueItems': json['ticket_revenue_items'] == null ? undefined : json['ticket_revenue_items'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'expenseItems': json['expense_items'] == null ? undefined : json['expense_items'],
        'totalExpenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
    };
}

  export function PatchedHoldCreateUpdateToJSON(json: any): PatchedHoldCreateUpdate {
      return PatchedHoldCreateUpdateToJSONTyped(json, false);
  }

  export function PatchedHoldCreateUpdateToJSONTyped(value?: Omit<PatchedHoldCreateUpdate, 'id'|'can_manage'|'host_team'|'show_team'|'booking_revision'|'accepted_at'|'created_by'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_terms': BookingTermsToJSON(value['bookingTerms']),
        'shared_settlement': SharedSettlementToJSON(value['sharedSettlement']),
        'host_notes': value['hostNotes'],
        'title': value['title'],
        'stage': value['stage'],
        'hold_date': value['holdDate'] == null ? undefined : ((value['holdDate']).toISOString().substring(0,10)),
        'promoter_team': value['promoterTeam'],
        'show': value['show'],
        'status': StatusAb7EnumToJSON(value['status']),
        'date_status': DateStatusEnumToJSON(value['dateStatus']),
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'notes': value['notes'],
        'load_in_time': value['loadInTime'],
        'soundcheck_time': value['soundcheckTime'],
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'attendance': value['attendance'],
        'show_capacity': value['showCapacity'],
        'ticket_revenue_items': value['ticketRevenueItems'],
        'ticket_revenue': value['ticketRevenue'],
        'bar_revenue': value['barRevenue'],
        'other_revenue': value['otherRevenue'],
        'expense_items': value['expenseItems'],
        'total_expenses': value['totalExpenses'],
        'is_settled': value['isSettled'],
        'settlement_date': value['settlementDate'] == null ? undefined : ((value['settlementDate'] as any).toISOString().substring(0,10)),
        'settlement_notes': value['settlementNotes'],
    };
}
